export const fabrikContent = (
  <>
    <div className="prose dark:prose-invert max-w-none">
      <h3>What We Did</h3>
      <p>Site design, site development, copywriting, brand refresh</p>

      <h3>About the Client</h3>
      <p>
        Fabrik is on a mission to take underutilized spaces and transform them
        into community spaces. Not just co-working – true &ldquo;third
        spaces&rdquo; available for anyone in the community to take advantage
        of.
      </p>

      <h3>The Challenge</h3>
      <p>
        As an early stage company, they are constantly testing and refining
        their assumptions. How does pricing work? Who pays for the service – the
        community builders? The owner? What are they willing to pay? What are
        the key benefits that resonate the most?
      </p>
      <p>
        Fabrik&rsquo;s team is tech savvy and more than capable of handling site
        maintenance. They needed a site that was beautiful, built in a way that
        was flexible, that they could ultimately control.
      </p>

      <h3>Designing Atomically</h3>
      <p>
        Township helped them build a powerful site using a modular,
        component-based architecture. Starting in Figma, we adopted an
        &ldquo;atomic design&rdquo; bottoms-up approach. We created flexible
        components that could be customized and combined to build pages.
      </p>
      <p>
        For example, we created a component that can be used to represent both
        locations and communities. Underneath the hood it&rsquo;s the same
        component. But it is flexible enough to support multiple data structures
        and can be visually represented in multiple ways.
      </p>

      <h3>Tech Savvy Clients Have Different Needs</h3>
      <p>
        Since they wanted to be able to update everything themselves, they had
        strong opinions on what each component should and should not be able to
        do. We ended up having many more touch points than most clients need (or
        want) to make sure the design system we were creating would serve their
        purposes long-term.
      </p>

      <h3>Communicating new ideas is different</h3>
      <p>
        The site has to educate a prospective member about a new idea. And
        educational sales are different – you&rsquo;re not comparing your
        offering to your competitors, because there aren&rsquo;t any.
        You&rsquo;re introducing a new type of category to the customer.
      </p>
      <p>
        There are many implications to this. What do their customers need to
        know, and in what order? What kind of photography do you use to show
        people in conversation, in a space that isn&rsquo;t a co-working space?
      </p>
      <p>
        We worked with Fabrik to make some educated guesses, but made sure the
        site was flexible enough to test those hypotheses and adjust. Fabrik can
        quickly run tests on value propositions, customer segments, benefit
        statements, etc.
      </p>

      <h3>Brand guidelines need to be flexible</h3>
      <p>
        Fabrik had worked with a branding firm already and had a set of brand
        guidelines in place. But once you see your brand reflected in your
        materials often you discover it needs to be tweaked.
      </p>
      <p>
        The initial brand guidelines had a bold color palette and big bold round
        typefaces. But once they saw them reflected on the site it felt too
        childish. So we made some adjustments to font choices and color palette
        to better reflect the vibe they were hoping to convey.
      </p>
      <p>
        It&rsquo;s important to keep an open mind when starting with brand
        guidelines. No one is going to see the PDF your agency created, but
        everyone is going to see the website.
      </p>
    </div>
  </>
);
